import Component from '@glimmer/component';
import RouteTemplate from 'ember-route-template';
import BannerComponent from '../../components/layout/banner/main';
import LiveNewsTicker from '../../components/layout/live-news-ticker';
import EsportsNewsComponent from '../../components/layout/news/esports-news';
import EsportsMatchResultsBanner from '../../components/layout/banner/esports-match-results';
import { pageTitle } from 'ember-page-title';

class EsportsGameComponent extends Component {
  <template>
    {{pageTitle @model.game.name}}
    <BannerComponent @theme='e-sport' @title='{{@model.game.name}} News' />
    <LiveNewsTicker />
    <EsportsMatchResultsBanner />
    <EsportsNewsComponent @articles={{@model.articles}} @popularPosts={{@model.popularArticles}} @liveStreamers={{@model.liveStreamers}} />
  </template>
}

export default RouteTemplate(EsportsGameComponent);
